// Keeps the page still behind an overlay (the mobile menu, the Filters panel). Reference counted, because
// two overlays can be open at once. Written from JS, so it needs no `:has()` support from the browser
let holders = 0;

export function lockPageScroll(): void {
  holders += 1;
  if (holders === 1) {
    document.documentElement.style.setProperty('overflow-y', 'hidden', 'important');
  }
}

export function unlockPageScroll(): void {
  if (holders === 0) return;
  holders -= 1;
  if (holders === 0) {
    document.documentElement.style.removeProperty('overflow-y');
  }
}
